import { merchantApi, rewardApi } from "@api";
import {
    AllCateIconNone,
    ComponentRewardList,
    EditIcon,
    IConClose,
    ModuleEmpty,
    SharedInput,
} from "@components";
import { enumStatus, enumTypes } from "@configs";
import {
    IAddressData,
    IAmphur,
    IDataReward,
    IDisplay,
    IGetRewardWithCate,
    IProvince,
    IReward,
    IRewardUsed,
    ISubDistrict,
} from "@interfaces";
import {
    fetchUser,
    selectApp,
    selectAuth,
    selectMerchant,
    selectNotSaveLocal,
    store,
} from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { RenderMeta, formatMessage, useNotify } from "@utils";
import { Col, Row, Select, Skeleton } from "antd";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { AllCateIcon } from "src/Components/icon/allCateIcon";
import { SuccessIcon } from "src/Components/icon/SuccessIcon";
import CountdownTimer from "src/Components/shared/CountDownTimer";
import { Pending } from "src/Components/shared/Pending";
import { Points } from "src/Components/shared/Point";
import PopupProcessingFail from "src/Components/shared/PopupProcessingFail";
import PopupPrecessingProgress from "src/Components/shared/PopupProcessingProgress";
import PopupWarning from "src/Components/shared/PopupWarning";
import { Redeemed } from "src/Components/shared/Redeemed";
import { Used } from "src/Components/shared/Used";
import { formatDateStartEnd } from "src/Utils/dateUtil";
import styled from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

const { Option } = Select;

interface IProps {
    usedData?: IRewardUsed | undefined;
}

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};

export const ModulesReward = (props: IProps) => {
    //props
    const history = useHistory();
    const { t } = useTranslation();
    const { showConfirm, userInfo } = useSelector(selectAuth);
    const dispatch = useDispatch();
    const { error, success, warning } = useNotify();
    const { usedData } = props;
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { navigationType } = useSelector(selectNotSaveLocal);

    //page states
    const [reward, setReward] = useState<IDataReward[]>([]);
    const [rewardList, setRewardList] = useState<IReward[]>([]);
    const [rTotal, setRTotal] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [spinning, setSpinning] = useState<boolean>(false);

    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [focusbenefit, setFocusBenefit] = useState<any>();
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [focusCoupon, setFocusCoupon] = useState<any>();
    const [cNote, setCNote] = useState<string>("");
    const [cateList, setCateList] = useState<any[]>([]);
    const [aCode, setACode] = useState<string>("");
    const [display, setDisplay] = useState<IDisplay>({
        province: "",
        district: "",
        subDistrict: "",
    });
    const [isConfirm, setIsConfirm] = useState<boolean>(false);
    const [redeemDetail, setRedeemDetail] = useState<any>();
    const [focusCate, setFocusCate] = useState<string>("all");
    const [isLoading, setIsloading] = useState(true);
    const [subDistrictIndex, setSubDistrictIndex] = useState<number>(0);
    const [isWarning, setIsWarning] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>("");
    const [shippingAddress, setShippingAddress] = useState<string>();
    const [page, setPage] = useState<number>(1);
    const [loadMore, setLoadMore] = useState<boolean>(false);
    const [points, setPoints] = useState<number>(0);
    const [amountRedeem, setAmountRedeem] = useState<number>(1);

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [itemFail, setItemFail] = useState<any[]>([]);
    const [isProcessingFail, setIsProcessingFail] = useState<boolean>(false);
    const [countItems, setCountItem] = useState<number>(0);
    const [variant, setVariant] = useState<string>("");

    const { langSetting } = useSelector(selectApp);
    const token = UserStore.getState().accessToken ?? store.getState().auth.auth?.accessToken;
    useEffect(() => {
        if (token) {
            handleGetReward();
            setIsloading(false);
        }
    }, [token, focusCate, limit]);

    useEffect(() => {
        if (token) {
            handleGetCate();
        }
    }, [token]);

    const handleCloseDetail = () => {
        setShowPopup(false);
        setAmountRedeem(1);
        closeAllPopup();
    };

    const handleCloseWarning = () => {
        setIsWarning(false);
    };

    const handleGetReward = async () => {
        try {
            if (limit === 10) {
                setSpinning(true);
            }
            let payload: IGetRewardWithCate = {
                limit: 100,
                page: page,
                ...(focusCate !== "all" && { rewardCategoryId: focusCate }),
            };
            const res = await rewardApi.getListReward(payload);
            setRTotal(res.data.totalDocs);
            let arr = res.data.docs;
            // let arr = res.data.docs.sort((firstEl: any, secondEl: any) => {
            //     if (secondEl.point > firstEl.point) {
            //         return -1;
            //     } else {
            //         return 0;
            //     }
            // });
            setRewardList(arr);
            // setReward(result);
        } finally {
            setSpinning(false);
        }
    };
    const handleLoadMore = async () => {
        setPage(page + 1);
        setLoadMore(true);
        let payload: IGetRewardWithCate = {
            limit: 100,
            page: page + 1,
            ...(focusCate !== "all" && { rewardCategoryId: focusCate }),
        };
        const res = await rewardApi.getListReward(payload);
        let arr = res.data.docs;
        setRewardList([...rewardList, ...arr]);
        setLoadMore(false);
    };

    const handleGetCate = async () => {
        await null;
        try {
            const res = await rewardApi.getRewardCate({
                limit: 50,
                page: 1,
            });
            setCateList(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const clickCate = (value: string) => {
        setPage(1);
        setFocusCate(value);
        setLimit(10);
    };

    const handleClick = (value: IReward, check: boolean) => {
        if (check) return;
        // history.push(REWARD + "/" + value._id);
        fetchDetail(value._id);
    };

    const openAddress = () => {
        let provinceListNew = provinceList;
        if (provinceListNew === undefined || provinceListNew === null) {
            provinceListNew = [];
        }
        let amphurListNew = amphurList;
        if (amphurListNew === undefined || amphurListNew === null) {
            amphurListNew = [];
        }
        let subDistrictListNew = subDistrictList;
        if (subDistrictListNew === undefined || subDistrictListNew === null) {
            subDistrictListNew = [];
        }
        let proObj = provinceListNew.find((item) => item?.province_id === addressData.province);
        let disObj = amphurListNew.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictListNew[parseInt(addressData?.subDistrict)];

        if (proObj !== undefined && disObj !== undefined && subObj !== undefined) {
            setDisplay({
                province: proObj?.province_name_tha || "",
                district: disObj?.amphur_name_tha || "",
                subDistrict: subObj?.district_name_tha || "",
            });
            setIsConfirm(true);
            setShowPage2(false);
            setShowPage3(true);
        }
    };

    const step2Next = () => {
        if (
            addressData?.address === "" ||
            addressData?.province === "" ||
            addressData?.district === "" ||
            addressData?.subDistrict === "" ||
            addressData?.postCode === ""
        ) {
            warning(t("page.enter_delivery_address"));
        } else {
            let proObj = provinceList.find((item) => item?.province_id === addressData.province);
            let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
            let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
            setDisplay({
                province: proObj?.province_name_tha || "",
                district: disObj?.amphur_name_tha || "",
                subDistrict: subObj?.district_name_tha || "",
            });

            setShowPage2(false);
            setShowPage3(true);
        }
    };

    const fetchDetail = async (id: any) => {
        if (id) {
            UIStore.setState({ isLoading: true });
            try {
                const res = await rewardApi.getDetailById(id);
                const data = res.data as IReward;

                setFocusBenefit(data);
                setACode(res.data.alienCodeTxts);
                setFocusCoupon(res.data);
                setShowPopup(true);
                // if (data.point && userInfo?.totalPoints)
                //     setCount(data.point <= userInfo.totalPoints ? 1 : 0);
            } catch (err: any) {
                if (err.response) {
                    error(formatMessage(err.response));
                } else error(t("message.error"));
            } finally {
                // setShowPopup(false);
                UIStore.setState({ isLoading: false });
            }
        }
    };

    useEffect(() => {
        if (userInfo) {
            const firstFetchAddress = async () => {
                if (userInfo?.contact?.address) {
                    await getAmphur(parseInt(userInfo?.contact?.address?.province), false);
                    const subDistricts = await getSubDistrictByamphur(
                        parseInt(userInfo?.contact?.address?.district),
                        false
                    );

                    const subDistrictIdx = subDistricts.findIndex(
                        (item: any) =>
                            `${item?.district_id}` === `${userInfo?.contact?.address?.subDistrict}`
                    );

                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        subDistrict: subDistrictIdx !== -1 ? subDistrictIdx.toString() : "",
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);
                }
            };
            firstFetchAddress();
        }
    }, []);

    useEffect(() => {
        getAllProvince();
    }, []);

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number, resetAddress = true) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        if (resetAddress) {
            setAddressData((prev) => ({
                ...prev,
                province: pId.toString(),
                district: "",
                subDistrict: "",
                postCode: "",
            }));
        }
        return allAmphur.data.result;
    };
    const getSubDistrictByamphur = async (aId: number, resetAddress = true) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        setSubDistrictIndex(
            subRes.data.result.findIndex(
                (item: any) => item?.district_id === userInfo?.contact?.address?.subDistrict
            )
        );
        if (resetAddress) {
            setAddressData((prev) => ({
                ...prev,
                province: subRes.data.result[0]?.province_id || "",
                district: aId.toString(),
                subDistrict: "",
                postCode: "",
            }));
        }
        return subRes.data.result;
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };

    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const onChangeSubDistrict = (value: any) => {
        let outSub = subDistrictList[value];
        setAddressData({
            ...addressData,
            subDistrict: value,
            postCode: outSub?.zipcode,
        });
    };

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
        </StyledSkeleton>
    );

    const [showpage1, setShowPage1] = useState(true);
    const [showpage2, setShowPage2] = useState(false);
    const [showpage3, setShowPage3] = useState(false);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [popupConfirmSuccess, setPopupConfirmSuccess] = useState(false);
    const [resultMessage, setResultMessage] = useState<any>([]);

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage2(false);
        setShowPage3(false);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
        setItemFail([]);
        setCountItem(0);
        setIsProcessingFail(false);
        setIsProcessing(false);
        setVariant("");
    };

    const closeAllPopupTrue = () => {
        setShowPage1(false);
        setShowPage2(false);
        setShowPage3(false);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(false);
        setShowPopup(false);
    };

    const clickPage1 = () => {
        // if (!userInfo?.totalPoints || userInfo?.totalPoints < focusCoupon?.point) {
        //     error(t("page.do_not_have_enough_points"));
        //     closeAllPopupTrue();
        //     closeAllPopup();
        //     UIStore.setState({ isLoading: false });
        //     return;
        // }
        if (focusCoupon?.isDelivery) {
            setShowPage1(false);
            setShowPage2(true);
            openAddress();
        } else {
            setShowPage1(false);
            setShowPage4(true);
        }
    };

    const closeConfirm = () => {
        if (focusCoupon?.isDelivery) {
            setShowPage4(false);
            setShowPage3(true);
            setShowPopupPage(true);
        } else {
            setShowPage4(false);
            setShowPage1(true);
            setShowPopupPage(true);
        }
    };

    const closeConfirmSuccess = () => {
        setPopupConfirmSuccess(false);
        setShowPage1(false);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(false);
        setShowPopup(false);
        setResultMessage([]);
        dispatch(fetchUser());
        setItemFail([]);
        setCountItem(0);
        setIsProcessingFail(false);
        setIsProcessing(false);
    };
    const checkReward = () => {
        setPopupConfirmSuccess(false);
        // dispatch(setNavigationType(4));
        // window.location.href = "/privilege/history";
        setShowPopup(false);
        setPopupConfirmSuccess(false);
        setResultMessage([]);
        dispatch(fetchUser());
        setItemFail([]);
        setCountItem(0);
        setIsProcessingFail(false);
        setIsProcessing(false);
        history.push("/privilege/history");
    };

    const onFinalRedeem = async () => {
        let proObj = provinceList.find((item) => item?.province_id === addressData.province);
        let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
        let addDisplay = {
            province: proObj?.province_name_tha || "",
            district: disObj?.amphur_name_tha || "",
            subDistrict: subObj?.district_name_tha || "",
        };
        let shipText = [
            addressData?.address,
            addDisplay?.province,
            addDisplay?.district,
            addDisplay?.subDistrict,
            addressData?.postCode,
        ].join(" ");

        if (focusCoupon.variants?.length > 0 && !variant) {
            setShowPage4(false);
            setShowPage1(true);
            setShowPopupPage(true);
            error(t("page.pleaseSelect") + " " + t("page.select_type").toLowerCase());
        } else {
            if (amountRedeem === 1) {
                UIStore.setState({ isLoading: true });
                try {
                    const res = await rewardApi.redeemed({
                        objectId: focusCoupon?._id,
                        quantity: 1,
                        status: enumStatus?.ACTIVE,
                        type: enumTypes?.REWARD,
                        variants: variant ? [variant] : [],
                        shippingAddress: focusCoupon?.isDelivery ? shipText : "",
                    });
                    let msg = res?.data?.message.split("||");
                    if (langSetting?.language === "ENGLISH") {
                        success(msg[1] || "");
                    } else {
                        success(msg[0] || "");
                    }
                    setShowPage4(false);
                    setShowResult(true);
                    setShowPopupPage(true);
                    setRedeemDetail(res.data?.reward);
                    setACode(res?.data?.reward?.alienCode);
                    setShippingAddress(res?.data?.reward?.shippingAddress);
                    setPoints(res?.data?.reward?.points);
                    dispatch(fetchUser());
                    UIStore.setState({ isLoading: false });
                } catch (err: any) {
                    if (err.response) {
                        setWarningMessage(formatMessage(err.response));
                        handleCloseDetail();
                        setPopupConfirmSuccess(false);
                        setIsWarning(true);
                    } else {
                        error(t("message.use_coupon.fail"));
                    }
                    UIStore.setState({ isLoading: false });
                    throw err; // re-throw เพื่อให้ caller จัดการ error ได้
                }
            } else {
                // สร้าง array ของ promises สำหรับการเรียก API 2 ตัวในแต่ละรอบ
                setShowPage4(false);
                setShowResult(false);
                setShowPopupPage(false);
                setIsProcessing(true);
                let loopCount = 0;
                const results: any = await Array.from({ length: amountRedeem })?.reduce(
                    async (prevPromise, _, i) => {
                        const acc: any = await prevPromise;

                        loopCount = i + 1; // ✅ นับรอบปัจจุบัน (เริ่มจาก 1)
                        if (i === 0) {
                            setCountItem(loopCount);
                        } else if (i < amountRedeem - 1) {
                            setCountItem(loopCount);
                        }

                        try {
                            const redeemRes = await rewardApi.redeemed({
                                objectId: focusCoupon?._id,
                                quantity: 1,
                                status: enumStatus?.ACTIVE,
                                type: enumTypes?.REWARD,
                                variants: variant ? [variant] : [],
                                shippingAddress: focusCoupon?.isDelivery ? shipText : "",
                            });

                            acc.push({ success: true, response: redeemRes, index: i + 1 });
                        } catch (error) {
                            acc.push({ success: false, error, index: i + 1 });
                        }
                        await new Promise((resolve) => setTimeout(resolve, 500));

                        if (loopCount === amountRedeem) {
                            setCountItem(amountRedeem);
                        }

                        return acc;
                    },
                    Promise.resolve([] as any[])
                );

                console.log("results", results);

                const successResults: any = [];
                const errorResults: any = [];

                results.forEach((result: any) => {
                    if (result.success) {
                        const res = result.response;
                        successResults.push({
                            index: result.index,
                            reward: res?.data?.reward,
                            alienCode: res?.data?.reward?.alienCode,
                            shippingAddress: res?.data?.reward?.shippingAddress,
                            points: res?.data?.reward?.points,
                        });
                    } else {
                        const msg: any = result.error.response?.data?.message.split("||");

                        errorResults.push({
                            index: result.index,
                            error: langSetting?.language === "ENGLISH" ? msg[1] : msg[0],
                        });
                    }
                });

                console.log("successResults", successResults);
                console.log("errorResults", errorResults);

                // แสดงผลตามจำนวนที่สำเร็จ
                if (successResults.length > 0) {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    setIsProcessing(false);
                    const successMessage =
                        langSetting?.language === "ENGLISH"
                            ? `${focusCoupon?.name}  x ${successResults.length}`
                            : `${focusCoupon?.name}  x ${successResults.length}`;

                    if (errorResults.length > 0) {
                        await new Promise((resolve) => setTimeout(resolve, 1000));
                        setItemFail(errorResults);
                        setIsProcessingFail(true);
                        setResultMessage((prev: any) => [...prev, successMessage]);
                    } else {
                        if (!isProcessingFail) {
                            await new Promise((resolve) => setTimeout(resolve, 1000));
                            setPopupConfirmSuccess(true);
                            setRedeemDetail(successResults[0].reward);
                            setACode(successResults[0].alienCode);
                            setShippingAddress(successResults[0].shippingAddress);
                            setPoints(successResults[0].points);
                            setResultMessage((prev: any) => [...prev, successMessage]);
                        }
                    }
                } else {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    setIsProcessing(false);
                    setWarningMessage(errorResults[0]?.error);
                    handleCloseDetail();
                    setIsWarning(true);
                }
                // return ผลลัพธ์ทั้งหมด
                return {
                    success: successResults,
                    errors: errorResults,
                    total: amountRedeem,
                    successCount: successResults.length,
                    errorCount: errorResults.length,
                };
            }
        }
    };

    const checkAmountQuotaLimit = focusCoupon?.quotaLimitList?.reduce((acc: any, cur: any) => {
        if (cur.limitProperty === "total") {
            if (!acc[cur.limitProperty]) {
                acc[cur.limitProperty] = 0;
            }
            acc[cur.limitProperty] += cur.limitAmount;
        }
        return acc;
    }, {});

    const handleCloseProcessing = () => {
        setIsProcessing(false);
    };

    const handleCloseProcessingFail = () => {
        setIsProcessingFail(false);
        setItemFail([]);
        setPopupConfirmSuccess(true);
    };

    const handleChangeVariant = (value: string) => {
        setVariant(value);
    };

    return (
        <>
            <RenderMeta title={t("meta.home")} />
            {cateList.length > 0 && (
                <StyledCateMenu themeColor={themes?.themeColor!}>
                    <Swiper slidesPerView={4.5} spaceBetween={20} pagination={true}>
                        <SwiperSlide key={0}>
                            <div className="layout-content-slide" onClick={() => clickCate("all")}>
                                <div className="img-content-slide">
                                    {focusCate === "all" ? (
                                        <AllCateIcon color={themes?.themeColor} />
                                    ) : (
                                        <AllCateIconNone color={themes?.themeColor} />
                                    )}
                                </div>
                                <a>All</a>
                            </div>
                        </SwiperSlide>
                        {cateList?.map((item: any, index: any) => (
                            <SwiperSlide key={index + 1}>
                                <div
                                    className="layout-content-slide"
                                    onClick={() => clickCate(item._id)}
                                >
                                    <StyledCatBox img={item.icon} clickicon={item.clickIcon}>
                                        <div
                                            className={
                                                "showiconcat " +
                                                (focusCate === item._id ? "active" : "")
                                            }
                                        ></div>
                                    </StyledCatBox>
                                    {/* <div className="img-content-slide">
                                </div> */}
                                    <a>{item.name}</a>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </StyledCateMenu>
            )}

            <div className="wrapper-content-slide"></div>
            {!spinning ? (
                rewardList?.length > 0 ? (
                    <ComponentRewardList
                        data={rewardList}
                        handleClick={handleClick}
                        rTotal={rTotal}
                        onLoadMore={handleLoadMore}
                        loadingPagination={loadMore}
                    />
                ) : (
                    <>
                        {rewardList?.length === 0 && !isLoading ? (
                            <StyledEmptyLayout>
                                <ModuleEmpty description="No data" />
                            </StyledEmptyLayout>
                        ) : (
                            // loadingComponent
                            loadingComponent
                        )}
                    </>
                )
            ) : (
                loadingComponent
            )}
            {isShowPopup && (
                <StyledShowPopup isConfirm={isConfirm} themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        {showpage3 ? (
                            <div className="topic-popup-product">
                                <div className="confirmation text-sub-header">
                                    Confirm delivery address
                                </div>
                            </div>
                        ) : null}
                        {showpage2 ? (
                            <div className="topic-popup-product">
                                <div className="confirmation text-sub-header">Delivery address</div>
                            </div>
                        ) : null}
                        <div className="close" onClick={handleCloseDetail}>
                            <IConClose width={16} />
                        </div>
                        {showpopuppage ? (
                            <div className="content-layout">
                                <div className="content">
                                    {showpage1 ? (
                                        <>
                                            <div className="header-product">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img src={focusCoupon.imageUrl[0]} />
                                                    </div>
                                                </div>
                                                <div className="topic-product">
                                                    {focusCoupon.name}
                                                </div>
                                                {/* <div className="total-point-product">
                                                    Total 300 Rewards
                                                </div> */}
                                                <div className="point-product">
                                                    <span>
                                                        <Points size={16} />
                                                    </span>
                                                    {focusCoupon.isPointByTier
                                                        ? (() => {
                                                              const myTierId =
                                                                  userInfo?.memberTier?.tierId ||
                                                                  userInfo?.memberTier?._id;
                                                              const myTier =
                                                                  focusCoupon.tierPointList.find(
                                                                      (tier: any) =>
                                                                          tier.tierId === myTierId
                                                                  );
                                                              return myTier
                                                                  ? myTier.point
                                                                  : focusCoupon.point;
                                                          })()
                                                        : focusCoupon.point}{" "}
                                                    {t("page._points")}
                                                </div>
                                            </div>
                                            <div className="content-product">
                                                {focusCoupon.description ? (
                                                    <>
                                                        <div className="topic-detail">
                                                            {t("page.conditions")}
                                                        </div>
                                                        <div
                                                            className="control-text"
                                                            dangerouslySetInnerHTML={{
                                                                __html: focusCoupon?.description,
                                                            }}
                                                        ></div>
                                                    </>
                                                ) : null}
                                            </div>

                                            {focusCoupon.variants.length > 0 && (
                                                <StyledVariant>
                                                    <label>{t("page.select_type")}</label>
                                                    <Select
                                                        className="select-variant"
                                                        onChange={handleChangeVariant}
                                                        value={variant}
                                                        placeholder={t("page.select_type")}
                                                    >
                                                        {focusCoupon.variants.map((item: any) => {
                                                            return (
                                                                <Option
                                                                    value={item?._id}
                                                                    key={item}
                                                                >
                                                                    {item?.name}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </StyledVariant>
                                            )}

                                            <StyledAmountRedeem>
                                                <span className="text-amount">
                                                    {"Amount Redeem"}
                                                </span>
                                                {/* {amountRedeem > checkAmountQuotaLimit?.total && (
                                                    <p className="text-over-limit">
                                                        {"**Reward usage limit exceeded"}
                                                    </p>
                                                )} */}
                                                <div className="button-action">
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            let amount = Number(amountRedeem) - 1;
                                                            if (amount <= 1) {
                                                                amount = 1;
                                                            }
                                                            setAmountRedeem(amount);
                                                        }}
                                                    >
                                                        <img src="../images/icon/circle-delete.svg" />
                                                    </span>
                                                    <span className="amount">{amountRedeem}</span>
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            let amount = Number(amountRedeem) + 1;
                                                            // if (amount >= 100) {
                                                            //     amount = 100;
                                                            // }
                                                            setAmountRedeem(amount);
                                                        }}
                                                    >
                                                        <img src="../images/icon/circle-add.svg" />
                                                    </span>
                                                </div>
                                            </StyledAmountRedeem>
                                            <StyledRedeemedBtn
                                                className="btn-redeems"
                                                themeColor={
                                                    // amountRedeem > checkAmountQuotaLimit?.total
                                                    //     ? "#E1E1E1"
                                                    //    :
                                                    themes?.themeColor!
                                                }
                                                textColor={"#fff"}
                                                onClick={clickPage1}
                                                // disabled={
                                                //     amountRedeem > checkAmountQuotaLimit?.total
                                                // }
                                            >
                                                {t("page.redeem")}
                                            </StyledRedeemedBtn>
                                        </>
                                    ) : null}
                                    {showpage2 ? (
                                        <>
                                            {/* <StyledSurvey mainColor={themes?.themeColor!}> */}
                                            <br />
                                            <div className="layout-address">
                                                <div className="box-address">
                                                    <SharedInput
                                                        name="freeTextAnswer"
                                                        value={addressData?.address}
                                                        onChange={(
                                                            e: React.ChangeEvent<HTMLFormElement>
                                                        ) =>
                                                            setAddressText(
                                                                e.target.value,
                                                                "address"
                                                            )
                                                        }
                                                        placeholder={t("page.address")}
                                                    />
                                                </div>
                                                <div className="box-address">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.province")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.county")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeProvince}
                                                                value={
                                                                    addressData.province === ""
                                                                        ? undefined
                                                                        : addressData.province
                                                                }
                                                                placeholder={t("page.province")}
                                                            >
                                                                {provinceList?.length > 0 &&
                                                                    provinceList?.map(
                                                                        (pItem, pIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={
                                                                                        pItem?.province_id
                                                                                    }
                                                                                    key={pIndex}
                                                                                >
                                                                                    {
                                                                                        pItem.province_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeAmphur}
                                                                value={
                                                                    addressData.district === ""
                                                                        ? undefined
                                                                        : addressData.district
                                                                }
                                                                placeholder={t("page.county")}
                                                            >
                                                                {amphurList?.length > 0 &&
                                                                    amphurList?.map(
                                                                        (aItem, aIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={
                                                                                        aItem?.amphur_id
                                                                                    }
                                                                                    key={aIndex}
                                                                                >
                                                                                    {
                                                                                        aItem?.amphur_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="box-address">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.district")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.zipcode")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeSubDistrict}
                                                                value={
                                                                    addressData.subDistrict === ""
                                                                        ? undefined
                                                                        : parseInt(
                                                                              addressData.subDistrict
                                                                          )
                                                                }
                                                                placeholder={t("page.district")}
                                                            >
                                                                {subDistrictList?.length > 0 &&
                                                                    subDistrictList?.map(
                                                                        (sItem, sIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={sIndex}
                                                                                    key={sIndex}
                                                                                >
                                                                                    {
                                                                                        sItem?.district_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                        <Col span={12}>
                                                            <SharedInput
                                                                name="freeTextAnswer"
                                                                value={addressData?.postCode}
                                                                onChange={(
                                                                    e: React.ChangeEvent<HTMLFormElement>
                                                                ) =>
                                                                    setAddressText(
                                                                        e.target.value,
                                                                        "postCode"
                                                                    )
                                                                }
                                                                styleParent={{ height: "48px" }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    border: "1px solid gray",
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            <StyledUsedBtn
                                                className="btn-redeem"
                                                themeColor={themes?.themeColor!}
                                                onClick={step2Next}
                                            >
                                                {t("page.redeem")}
                                            </StyledUsedBtn>
                                            {/* </StyledSurvey> */}
                                        </>
                                    ) : null}
                                    {showpage3 ? (
                                        <>
                                            <div className="content-product">
                                                <div className="form-content-product">
                                                    <div className="confirm-section">
                                                        <div
                                                            className="edit-icon"
                                                            onClick={() => {
                                                                setShowPage2(true);
                                                                setShowPage3(false);
                                                            }}
                                                        >
                                                            <EditIcon size={20} />
                                                        </div>
                                                        <p>
                                                            {addressData?.address} &nbsp;
                                                            {display?.province} &nbsp;
                                                            {display.district} &nbsp;
                                                            {display.subDistrict} &nbsp;
                                                            {addressData?.postCode}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <StyledUsedBtn
                                                className="btn-redeem"
                                                themeColor={themes?.themeColor!}
                                                onClick={() => {
                                                    setShowPage3(false);
                                                    setShowPage4(true);
                                                    setShowPopupPage(false);
                                                }}
                                            >
                                                {t("page.redeem")}
                                            </StyledUsedBtn>
                                        </>
                                    ) : null}

                                    {showresult ? (
                                        <>
                                            <div className="set-result">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img
                                                            src={
                                                                focusCoupon
                                                                    ? focusCoupon.imageUrl[0]
                                                                    : ""
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="fixed-layout">
                                                    <div className="content-info">
                                                        <div className="header-product">
                                                            <div className="topic-product">
                                                                {focusCoupon.name}
                                                            </div>
                                                            {/* <div className="total-point-product">
                                                        100 left
                                                    </div> */}
                                                            <div className="point-product">
                                                                <span>
                                                                    <Points size={16} />
                                                                </span>
                                                                {/* {focusCoupon.isPointByTier ? (
                                                                    (() => {
                                                                        const myTierId = userInfo?.memberTier?.tierId || userInfo?.memberTier?._id;
                                                                        const myTier = focusCoupon.tierPointList.find((tier: any) => tier.tierId === myTierId);
                                                                        return myTier ? myTier.point : focusCoupon.point;
                                                                    })()
                                                                ) : (
                                                                    focusCoupon.point
                                                                )} */}
                                                                {points}
                                                            </div>
                                                            <div className="expier-product">
                                                                {t("page.exp")} :{" "}
                                                                {formatDateStartEnd(
                                                                    focusCoupon.startDate,
                                                                    focusCoupon.endDate
                                                                )}
                                                            </div>

                                                            {focusCoupon.variants?.length > 0 && (
                                                                <div
                                                                    className="expier-product"
                                                                    style={{ marginTop: 10 }}
                                                                >
                                                                    {t("page.select_type")} :{" "}
                                                                    {focusCoupon.variants.find(
                                                                        (item: any) =>
                                                                            item._id === variant
                                                                    )?.name || "-"}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {focusCoupon?.autoUseTime?.enabled && (
                                                        <div className="countdownBox">
                                                            <CountdownTimer
                                                                targetDate={
                                                                    redeemDetail?.autoUseTimeOut
                                                                }
                                                            />
                                                            <div style={{ textAlign: "center" }}>
                                                                The code will expire{" "}
                                                                {focusCoupon?.autoUseTime?.time}{" "}
                                                                {focusCoupon?.autoUseTime
                                                                    ?.timeUnit === "s"
                                                                    ? "seconds "
                                                                    : focusCoupon?.autoUseTime
                                                                          ?.timeUnit === "m"
                                                                    ? "minutes "
                                                                    : focusCoupon?.autoUseTime
                                                                          ?.timeUnit === "h"
                                                                    ? "hours "
                                                                    : " "}
                                                                after clicking the confirm button.
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="action-layout">
                                                        {focusCoupon?.isDelivery ? null : (
                                                            <div className="qr-layout">
                                                                <div className="qr-box">
                                                                    <QRCode
                                                                        value={
                                                                            aCode
                                                                                ? aCode
                                                                                : redeemDetail?.ticketCode ||
                                                                                  ""
                                                                        }
                                                                        size={150}
                                                                    />
                                                                </div>
                                                                <StyledCodeButton
                                                                    mainColor={themes?.themeColor!}
                                                                >
                                                                    {aCode
                                                                        ? aCode
                                                                        : redeemDetail?.ticketCode ||
                                                                          "---"}
                                                                </StyledCodeButton>
                                                            </div>
                                                        )}

                                                        {(focusCoupon?.alienCode ||
                                                            aCode !== "") && (
                                                            <StyledAlienCode
                                                                mainColor={themes?.themeColor!}
                                                            >
                                                                <div className="title text-normal-bold">
                                                                    {t("page.rewardCode")}
                                                                </div>
                                                                <div className="alien-code-btn">
                                                                    {focusCoupon?.alienCode ||
                                                                        aCode}
                                                                </div>
                                                                <div className="custom-barcode">
                                                                    <Barcode
                                                                        value={
                                                                            focusCoupon?.alienCode ||
                                                                            aCode
                                                                        }
                                                                    />
                                                                </div>
                                                            </StyledAlienCode>
                                                        )}

                                                        {focusCoupon.notiStatus === "REDEEMED" ? (
                                                            <p className="redeemed-product">
                                                                <span className="redeemed">
                                                                    <Redeemed color="#336C51" />
                                                                </span>
                                                                {focusCoupon.notiStatus}
                                                            </p>
                                                        ) : null}
                                                        {focusCoupon.notiStatus === "PENDING" ? (
                                                            <p className="pending-product">
                                                                <span className="pending">
                                                                    <Pending color="#ED773A" />
                                                                </span>
                                                                {focusCoupon.notiStatus}
                                                            </p>
                                                        ) : null}
                                                        {focusCoupon.notiStatus === "USED" ? (
                                                            <p className="used-product">
                                                                <span className="used">
                                                                    <Used color="#336C51" />
                                                                </span>
                                                                {focusCoupon.notiStatus}
                                                            </p>
                                                        ) : null}
                                                        {focusCoupon?.isDelivery ? (
                                                            <div className="result-delivery">
                                                                <div className="title-delivery">
                                                                    {t("page.youDelivery")}
                                                                </div>
                                                                <div className="box-delivery">
                                                                    <span>
                                                                        <img src="../../images/pin-address.svg" />
                                                                        Address
                                                                    </span>
                                                                    {/* <p>
                                                                        {addressData?.address} &nbsp;
                                                                        {display?.province} &nbsp;
                                                                        {display.district} &nbsp;
                                                                        {display.subDistrict} &nbsp;
                                                                        {addressData?.postCode}
                                                                    </p> */}
                                                                    <p>{shippingAddress}</p>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <p className="note">
                                                                {focusCoupon?.noticeText
                                                                    ? focusCoupon?.noticeText
                                                                    : t("page.desConfirm")}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                        {showpage4 ? (
                            <StyledPopupRedeem
                                isConfirm={isConfirm}
                                themeColor={themes?.themeColor!}
                            >
                                <div className="box-popupconfirm">
                                    <div className="img-popupconfirm">
                                        <img
                                            src={
                                                merchant?.themes?.basicThemeSetting?.iconGeneral[0]
                                                    ?.image
                                                    ? merchant?.themes?.basicThemeSetting
                                                          ?.iconGeneral[0]?.image
                                                    : ""
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="title">
                                        <div className="text-sub-header">
                                            {t("page.pleaseconfirm")}
                                        </div>
                                        {focusCoupon?.autoUseTime?.enabled ? (
                                            <div className="text-desc">
                                                The code will expire in{" "}
                                                {focusCoupon?.autoUseTime?.time}{" "}
                                                {focusCoupon?.autoUseTime?.timeUnit === "s"
                                                    ? "seconds "
                                                    : focusCoupon?.autoUseTime?.timeUnit === "m"
                                                    ? "minutes "
                                                    : focusCoupon?.autoUseTime?.timeUnit === "h"
                                                    ? "hours "
                                                    : " "}
                                                confirmation.
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="btn-popupconfirm">
                                        <StyledUsedBtn
                                            className="btn-cancel"
                                            themeColor={themes?.themeColor!}
                                            onClick={closeConfirm}
                                        >
                                            {t("page.cancel")}
                                        </StyledUsedBtn>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            // onClick={() => { setShowPage4(false); setShowResult(true); setShowPopupPage(true); }}
                                            onClick={onFinalRedeem}
                                        >
                                            {t("page.confirm")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        ) : null}

                        {popupConfirmSuccess ? (
                            <StyledPopupRedeem
                                isConfirm={isConfirm}
                                themeColor={themes?.themeColor!}
                            >
                                <div className="box-popupconfirm">
                                    <span
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "-30px",
                                            paddingBottom: "22px",
                                        }}
                                    >
                                        <SuccessIcon />
                                    </span>
                                    <div className="title" style={{ paddingBottom: "10px" }}>
                                        <div
                                            className="text-sub-header"
                                            style={{ textAlign: "center" }}
                                        >
                                            {"Reward redeemed successfully!"}
                                        </div>
                                        <div
                                            className="text-desc"
                                            style={{
                                                fontSize: "14px",
                                                lineHeight: "30px",
                                                color: "#000",
                                            }}
                                        >
                                            {resultMessage?.map((item: string, index: number) => (
                                                <span key={index}>{item}</span>
                                            ))}
                                        </div>
                                        <div
                                            className="text-desc"
                                            style={{
                                                fontSize: "14px",
                                                color: "#9B9B9B",
                                                textAlign: "center",
                                            }}
                                        >
                                            {"You can find it in your redemption history."}
                                        </div>
                                    </div>

                                    <div className="btn-popupconfirm">
                                        <StyledUsedBtn
                                            className="btn-cancel"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => closeConfirmSuccess()}
                                        >
                                            {t("page.cancel")}
                                        </StyledUsedBtn>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => checkReward()}
                                        >
                                            {"Check Reward"}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        ) : null}
                    </div>
                </StyledShowPopup>
            )}

            {isWarning && <PopupWarning onClose={handleCloseWarning} text={warningMessage} />}
            {isProcessing && (
                <PopupPrecessingProgress
                    onClose={handleCloseProcessing}
                    text={"Please wait a moment, we are processing redeem your reward"}
                    countItem={countItems}
                    amount={amountRedeem}
                />
            )}
            {isProcessingFail && (
                <PopupProcessingFail
                    onClose={handleCloseProcessingFail}
                    text={`Processing fail ${itemFail?.length || 0} items`}
                    listFail={itemFail}
                />
            )}
        </>
    );
};

const StyledSkeleton = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 12px;
    .ant-skeleton {
        display: flex;
        width: 100%;
        flex-direction: column;
        .ant-skeleton-header {
            padding-right: 0;
            span {
                width: 100%;
                height: 167px;
                border-radius: 14px;
            }
        }
        .ant-skeleton-title {
            width: 100% !important;
            height: 10px;
            border-radius: 4px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0 !important;
            li {
                height: 10px;
                border-radius: 4px;
                &:last-child {
                    margin-top: 15px;
                }
            }
        }
    }
`;

const StyledCatBox = styled.div<{ img: string; clickicon: string }>`
    .showiconcat {
        background-image: url(${(props) => props.img});
        background-size: 50px;
        width: 50px;
        height: 50px;
        margin: 0 auto;
    }
    .active {
        background-image: url(${(props) => props.clickicon});
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string; textColor?: string }>`
    padding: 14.5px 32px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    width: -webkit-fill-available !important;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledRedeemedBtn = styled.button<{ themeColor: string; textColor?: string }>`
    padding: 14.5px 32px;
    color: ${(p) => p.textColor};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    width: -webkit-fill-available !important;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledPopupRedeem = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
        .text-desc {
            font-size: 11px;
            color: #000;
            font-weight: 400;
        }
    }
`;

const StyledCodeButton = styled.div<{ mainColor?: string }>`
    position: absolute;
    background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledAlienCode = styled.div<{ mainColor?: string }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    flex-direction: column;
    margin-bottom: 10px;
    .title {
        margin-bottom: 10px;
    }
    .alien-code-btn {
        color: #c4a363;
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        width: 100%;
        text-align: center;
        padding: 18px 0;
        background-color: #ddd;
        border-radius: 12px;
        background-image: url(../../images/bg-code.svg);
        background-size: cover;
    }
`;

const StyledShowPopup = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .layout-address {
        margin-bottom: 50px;
        &:after {
            content: "";
            position: absolute;
            right: -24px;
            top: -24px;
            background-color: #fff;
            width: 30px;
            height: 30px;
        }
        &:before {
            content: "";
            position: absolute;
            left: -24px;
            top: -24px;
            background-color: #fff;
            width: 30px;
            height: 30px;
        }
        .input-title {
            margin-bottom: 5px;
        }
        .box-address {
            margin-bottom: 30px;
        }
        .ant-select-arrow {
            color: ${(p) => p.themeColor} !important;
            stroke-width: 50px;
            stroke: ${(p) => p.themeColor};
        }
        .ant-checkbox-inner {
            border-color: ${(p) => p.themeColor};
        }
        :hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
            background-color: ${(p) => p.themeColor} !important;
        }
        :not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
        :where(.css-dev-only-do-not-override-1kuana8).ant-checkbox:not(.ant-checkbox-disabled):hover
            .ant-checkbox-inner {
            border-color: ${(p) => p.themeColor};
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        &:after {
            content: "";
            position: absolute;
            right: -24px;
            top: -24px;
            background-color: #fff;
            width: 50px;
            height: 50px;
        }
        &:before {
            content: "";
            position: absolute;
            left: -24px;
            top: -24px;
            background-color: #fff;
            width: 50px;
            height: 50px;
        }
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
        .confirm-section {
            background-color: #f7f7f7;
            padding: 20px;
            position: relative;
            border-radius: 12px;
            color: #000;
            z-index: 2;
            .edit-icon {
                position: absolute;
                right: 10px;
                top: 5px;
                cursor: pointer;
                text-align: right;
            }
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .result-delivery {
                .title-delivery {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: center;
                    color: #9b9b9b;
                    margin-bottom: 15px;
                }
                .box-delivery {
                    background-color: #f7f7f7;
                    border-radius: 12px;
                    padding: 8px 16px;
                    text-align: center;
                    span {
                        font-size: 12px;
                        color: #336c51;
                        line-height: 15px;
                        margin-bottom: 10px;
                        img {
                            margin-right: 5px;
                        }
                    }
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .set-result {
            .layout-img {
                text-align: center;
                margin-top: -100px;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .header-product {
                margin-top: 0;
            }
            .fixed-layout {
                height: 60dvh;
                overflow: scroll;
            }
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            margin-bottom: 50px;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .control-text {
                max-height: 150px;
                overflow: scroll;
                width: 100%;
                word-break: break-all;
            }
            ul {
                li {
                    font-size: 12px;
                    line-height: 16px;
                    color: #9b9b9b;
                }
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .countdownBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .result-delivery {
                .title-delivery {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: center;
                    color: #9b9b9b;
                    margin-bottom: 15px;
                }
                .box-delivery {
                    background-color: #f7f7f7;
                    border-radius: 12px;
                    padding: 8px 16px;
                    text-align: center;
                    font-size: 12px;
                    line-height: 15px;
                    span {
                        font-size: 12px;
                        color: #336c51;
                        line-height: 15px;
                        margin-bottom: 10px;
                        display: block;
                        img {
                            margin-right: 5px;
                        }
                    }
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const StyledEmptyLayout = styled.div`
    .ant-empty-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
    }
`;
const StyledLoading = styled.div`
    margin: 24px 0;
    padding: 24px;
    .card {
        background-color: ${(p) => p.theme.colors.card};
        box-shadow: 1px 3px 6px rgba(0, 0, 0, 0.16), 1px 3px 6px rgba(0, 0, 0, 0.23);
        width: 240px;
        min-width: 209px;
        margin: 0 24px 28px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px;
        span {
            width: 100%;
        }
        .card-bottom {
            width: 100%;
            padding: 10px 20px;
        }
    }
    .row {
        display: flex;
        margin-bottom: 1.5rem;
        overflow: hidden;
    }
    .title {
        width: 30%;
        margin-bottom: 30px;
    }
`;

const StyledHighLight = styled.span<{ themeColor: string }>`
    position: relative;
    color: #fff;
    background-color: ${(props) => props.color || props.themeColor};

    font-size: 12px;
    line-height: 14px;
    padding: 4px 8px 6px;
    border-radius: 4px;
    z-index: 2;
    &:after {
        content: "";
        width: 7px;
        height: 7px;
        background-color: ${(props) => props.color || props.themeColor};
        position: absolute;
        bottom: -6px;
        left: 50%;
        rotate: 45deg;
        transform: translateX(-50%);
        z-index: 1;
    }
`;

const StyledCateMenu = styled.div<{ themeColor: string }>`
    margin: 0 16px 10px;
    padding-top: 16px;
    padding-bottom: 16px;
    .swiper-container {
        /* overflow: unset; */
        padding-bottom: 16px;
    }
    .swiper-pagination {
        bottom: 0;
        .swiper-pagination-bullet {
            background-color: ${(p) => p.themeColor};
            margin: 0;
            border-radius: 0;
            width: 16px;
            height: 3px;
            &:first-child {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
            }
            &:last-child {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
            }
        }
        .swiper-pagination-bullet-active {
            border-radius: 10px;
        }
    }
    .layout-content-slide {
        text-align: center;
        display: inline-block;
        width: 90px;
        // margin-right:40px;
        position: relative;
        // padding-right: 5px;
        a {
            font-size: 12px;
            line-height: 14px;
            color: #000;
            font-weight: 500;
        }
        p {
            font-size: 10px;
            line-height: 12px;
            color: #9b9b9b;
        }
        .img-content-slide {
            width: 50px;
            height: 50px;
            // border-radius: 100%;
            /* overflow: hidden; */
            margin: 0 auto 5px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 12px;
                border: 1px solid ${(p) => p.themeColor};
            }
            svg {
                border-radius: 14px;
            }

            a {
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        .layout-hot-content {
            position: absolute;
            top: 0;
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
`;

const StyledAmountRedeem = styled.div`
    display: flex;
    padding: 12px 0px 2rem;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    .text-amount {
        align-self: stretch;
        color: #9b9b9b;
        text-align: center;
        font-size: var(--Size-1sm, 12px);
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        padding-bottom: 10px;
    }
    .text-over-limit {
        align-self: stretch;
        color: #e53223;
        text-align: center;
        font-size: var(--Size-2xs, 11px);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 10px;
        margin-top: -16px;
    }
    .button-action {
        display: flex;
        align-items: center;
        gap: 8px;
        .amount {
            width: 36px;
            color: #000;
            text-align: center;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
`;

const StyledVariant = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    label {
        color: #9b9b9b;
        font-size: var(--Size-1sm, 12px);
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
    }
    .select-variant {
        width: 100%;
        .ant-select-selection {
            border-color: #d9d9d9 !important;
            // box-shadow: none !important;
            height: 48px;
            font-size: 16px;
            /* color: inherit; */
            display: flex;
            flex-direction: column;
            justify-content: center;
            /* background-color: #fff; */
            /* margin-bottom: 27px; */
            border-radius: 6px;
        }
    }
`;
